<template>

    <div class="sel-opts-wrapper" :class="{ active : activeOverlay}">
        <div class="sel-opts-outer" ref="outer">
            <div class="dft-preview ft-bld" @click.prevent="toggleOpts">
                <span class="txt">
                    {{ caption }} : 
                    <span class="txt-main">{{ currentOpt }}</span>
                </span>
                <span class="arw"></span>
            </div>
            <div class="expand-outer" v-show="activeOverlay">
                <div class="bg"></div>
                <div class="in">
                    <div class="line" v-for="opt, index in opts" :key="index" :class="{ active : currentOpt === opt }" @click.prevent="optSelection(opt)">
                        <span class="name">{{ opt }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        name: 'SelectOptsWrapper',

        props: {
            caption: String,
            opts: Array,
            value: String
        },

        watch: {
            value(to) {
                this.currentOpt = to
            }
        },

        data() {
            return {
                currentOpt: '',
                activeOverlay: false
            }
        },

        mounted() {
            this.currentOpt = this.value || this.opts[0]
            this.$emit("input", this.currentOpt)
            document.body.addEventListener('click', this.bodyClick)
        },

        methods: {

            toggleOpts() {
                this.activeOverlay = !this.activeOverlay
            },

            optSelection(option) {
                if (this.currentOpt == option) return
                this.currentOpt = option
                this.toggleOpts()
                this.$emit("input", this.currentOpt)
                // this.$parent.$emit("newFont")
            },

            bodyClick(event) {
                if (!this.activeOverlay) return
                let el = '.' + this.$refs.outer.classList[0] + ' *'
                if (!event.target.matches(el))
                    this.activeOverlay = false
            },

        }


    }

</script>